<template>
  <div class="range-picker">
    <v-text-field v-model="dateRangeText" label="Currently viewing data for" append-icon="mdi-calendar"
      @click:append="dialog = true" readonly></v-text-field>


    <v-dialog @keydown.esc="dialog = false" v-model="dialog">
      <v-date-picker v-model="selectedRange" range :first-day-of-week="4" picker-date></v-date-picker>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  props: ['range'],

  data() {
    return {
      selectedRange: this.range || this.getDefaultWeek(),
      dialog: false
    }
  },

  computed: {
    dateRangeText() {

      return this.selectedRange.join(' ~ ')

    }
  },


  watch: {

    selectedRange(val) {

      if (val.length == 2) { //if the two dates have been selected

        this.$emit('reloadData', val)
        this.dialog = false

      }
    }

  },

  methods: {
    loadData(selectedRange) { this.$emit('reloadData', selectedRange) }
  }

}
</script>